// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"solarpanel_400w_rigid_animationWrapper__TlWBk"};